module.exports = __webpack_public_path__ + "static/media/problem-solving.b0bd2775.svg";